import { z } from "zod/v4";

export const folderSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	parent_id: z.string().uuid().nullable().optional(),
	name: z.string(),
	created_by: z.string().uuid(),
	created_at: z.coerce.date(),
});

export const documentSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	folder_id: z.string().uuid().nullable().optional(),
	name: z.string(),
	file_key: z.string(),
	mime_type: z.string(),
	size_bytes: z.number(),
	uploaded_by: z.string().uuid(),
	uploaded_by_name: z.string().optional(),
	download_url: z.string().optional(),
	created_at: z.coerce.date(),
});

export const createFolderSchema = z.object({
	name: z.string().min(1, "Name is required"),
	parent_id: z.string().uuid().nullable().optional(),
});
